declare var swal: any;

import {
  Component,
  ViewChild,
  AfterViewInit,
  OnInit,
  AfterViewChecked,
  Input
} from "@angular/core";
import { TurtleService } from "../services/turtle.service";
import { ColorService } from "../services/color.service";
import { LanguageService } from "../services/language.service";
import { CommandsService } from "../services/commands.service";
import { CanvasService } from "../services/canvas.service";
import { DebuggerService } from "app/services/debugger.service";
import { BlocksService } from "../services/blocks.service";
import { BluetoothService } from "../services/bluetooth.service";
import { RootService } from "../services/root.service";
import { GridService } from '../services/grid.service';
import { TeacherToolService } from '../services/teachertool.service';

declare var swal: any;

@Component({
  selector: "app-canvas",
  templateUrl: "./canvas.component.html"
})
export class CanvasComponent {
  // variables related to the canvas itself
  private width: number;
  private height: number;

  // Internal readjustmens
  //static readonly STROKE_LENGTH_MULTIPLIER = 1 / 1.8;
  //static MULTIPLIER;
  static readonly TURTLE_SIZE_MULTIPLIER = 0.4;

  // variables related to canvas moving
  private isActive = false;
  private startDragX: number;
  private startDragY: number;
  private turtleImgLocation = "app/img/turtles/turtle0.png";
  static updateDimension;

  static stop = false;

  // Function that's used as a callback for turtle image changes by the header component.
  static turtleImgLoadFunction;

  // static reference
  static canvasComponent: CanvasComponent;

  //Logging
  static aufgabe = 1;
  static startTime;

  @ViewChild("b") backgroundCanvas;
  @ViewChild("d") drawCanvas;
  @ViewChild("t") turtleCanvas;

  // TODO: this can be removed right?
  private praises = [
    "Klasse Job!",
    "Brillante Arbeit! Danke!!!",
    "Ich bin echt stolz auf dich.",
    "Wow! Ich hatte keine Ahnung wie gut du bist.",
    "Daumen hoch.",
    "Ganz ehrlich: Anfangs war ich mir nicht sicher. Aber du hast alle Erwartungen weit, weit übertroffen.",
    "Phantastisches Ergebnis. Ich gratuliere!",
    "Das ist grossartig!",
    "Deine Lösung ist genial!",
    "Das ist sehr gut geworden - Bravo!",
    "Toll!",
    "Jetzt hast du es erfasst.",
    "Was ich sehe, ist perfekt, akurat, komplett durchdacht, puenktlich in der Zeit - Gut gemacht!",
    "Wie immer: phantastische Arbeit!",
    "Und ich dachte schon, du kannst dich nicht mehr steigern... Mein Fehler!",
    "Du bist ein guter Denker.",
    "Ein Meisterstueck - vor allem in der Kuerze der Zeit!",
    "Ich muss das noch mal sagen: Du hast da wirklich erstklassige Arbeit geleistet!",
    "Wunderbar, genau das habe ich mir als Ergebnis gewuenscht!",
    "Mensch bist du gut! Das ist jetzt mehr, als man erwarten konnte...",
    "Auf dich kann man zaehlen - immer und immer wieder!",
    "Glückwunsch",
    "Du bist ein Superstar",
    "... und das Problem ist gelöst. Grossartige Arbeit",
    "Du kannst stolz auf dich sein",
    "Sensationell!",
    "Du bist der Beste",
    "das war nicht einfach, aber du hast es geschafft.",
    "Nichts kann dich jetzt noch stoppen",
    "Du machst grosse Fortschritte",
    "Ich wusste, du würdest es hinbekommen",
    "Fantastisch!",
    "Ich kann nur sagen: Wow, das ist wirklich gut!",
    "Ich mag es, wie du denkst",
    "Ausgezeichnet, wie du das hinbekommen hast!",
    "Du bist sehr kreativ",
    "Zeig uns, was du kannst!",
    "Mit Vollgas voraus.",
    "Du bist nicht mehr zu bremsen"
  ];

  constructor(
    private lang: LanguageService,
    private debuggerService: DebuggerService,
    private commandsService: CommandsService,
    private canvasService: CanvasService,
    private blocks: BlocksService,
    private bluetoothService: BluetoothService,
    private rootRobotService: RootService,
    private gridService: GridService,
    private teacherToolService: TeacherToolService
  ) {
    CanvasComponent.canvasComponent = this;

    document.onmouseup = function() {
      this.isActive = false;
    }.bind(this);
  }

  flush() {
    this.canvasService.flushCanvas();
  }

  // set canvas not to be moveable manually
  setInactive(e: MouseEvent) {
    this.isActive = false;
  }

  // set canvas to be moveable manually
  setActive(e: MouseEvent) {
    // determine positioning of canvas in the window at the moment
    this.startDragX = e.clientX;
    this.startDragY = e.clientY;

    // set canvas to be moveable
    this.isActive = true;
  }

  // Detect window resize and adjust dimensions accordingly
  onWindowResize(e: Event) {
    if (CanvasService.initialized) {
      CanvasComponent.updateDimension();
    }
  }

  // perform dragging on canvas
  draggingCanvas(e: MouseEvent) {
    if (this.isActive) {
      let dragDeltaX = e.clientX - this.startDragX;
      let dragDeltaY = e.clientY - this.startDragY;
      this.startDragX = e.clientX;
      this.startDragY = e.clientY;
      // TODO: I think it would be possible for the delta to become an incorrect value if the user resizes the window *while* dragging. This can
      // happen if he fullscreens the application with a keyboard shortcut
      this.canvasService.clearTurtle();
      this.canvasService.dragCanvas(-dragDeltaX, -dragDeltaY);
      this.canvasService.drawTurtle();
    }
  }

  ngOnInit() {
    if (this.blocks.isBlockMode()) {
      document
        .getElementById("canvascontainer")
        .classList.add("canvascontainerBlocks");
      document
        .getElementById("canvascontainer")
        .classList.remove("canvascontainer");
    }

    //CanvasComponent.MULTIPLIER = CanvasComponent.STROKE_LENGTH_MULTIPLIER;

    CanvasComponent.updateDimension = function() {
      let canvasD = <HTMLCanvasElement>document.getElementById("canvasD");
      let canvasT = <HTMLCanvasElement>document.getElementById("canvasT");

      canvasD.width = canvasD.offsetWidth;
      canvasD.height = canvasD.offsetHeight;
      canvasT.width = canvasT.offsetWidth;
      canvasT.height = canvasT.offsetHeight;

      // Adjust canvas size internally
      this.canvasService.setCanvasDimension(canvasD.width, canvasD.height);

      // Changing size properties of canvas leads to clearing, need to draw again
      this.flush();
    }.bind(this);

    //load turtle image.
    CanvasComponent.turtleImgLoadFunction = function() {
      let img = this.canvasService.getImg();
      let scaledWidth = img.width * CanvasComponent.TURTLE_SIZE_MULTIPLIER;
      let scaledHeight = scaledWidth * (img.height / img.width);
      img.width = scaledWidth;
      img.height = scaledHeight;

      this.canvasService.flushCanvas(this.turtle);
    }.bind(this);
  }

  ngAfterViewInit() {
    // prepare canvas (reset all variables, set turtle, its position and orientation)
    //this.load();
  }

  // prepare canvas
  public load() {
    this.width = document.getElementById("canvascontainer").offsetWidth;
    this.height = document.getElementById("canvascontainer").offsetHeight;

    this.canvasService.contextBackground = this.backgroundCanvas.nativeElement.getContext(
      "2d"
    );
    this.canvasService.contextDraw = this.drawCanvas.nativeElement.getContext(
      "2d"
    );
    this.canvasService.contextTurtle = this.turtleCanvas.nativeElement.getContext(
      "2d"
    );

    this.canvasService.initializeCanvas(this.width, this.height);

    // load turtle picture
    var img = new Image();
    img.src = this.turtleImgLocation;
    img.addEventListener("load", CanvasComponent.turtleImgLoadFunction);
    this.canvasService.setImg(img);

    //draw turtle at rigth location on canvas
    this.canvasService.drawTurtleInit();

    // display turtle
    this.canvasService.storeTurtleInfoForFlush();
  }

  // #########################################################################################################################################
  //
  // library functions for XLogo commands, those are called from the visitor
  //
  // #########################################################################################################################################

  //command GO added after pressing "ENTER" to be able to communicate with Bluetooth devices
  //Send a sequence of commands to device
  go() {
    if (this.bluetoothService.checkWhetherBluetoothConnected()) {
      this.bluetoothService.go();
    }
  }

  executionFinished() {
    this.gridService.executionFinished();
  }

  //command wait added to be able to send it to BlueBot.
  //This will only be executed when a BlueBot is connected
  wait() {
    if (this.bluetoothService.checkWhetherBluetoothConnected()) {
      this.bluetoothService.wait();
    }
  }

  getColor(arg: any): ColorService {
    return new ColorService(arg);
  }

  reportError(errormessages: string[], input: string) {
    this.commandsService.addErrorMessage(errormessages, input);
  }

  /* ------------------------------------Everything related to the navigation tasks----------------------------------- */
  nextExercise() {
    this.gridService.nextExercise();
  }

  prevExercise() {
    this.gridService.prevExercise();
  }

  quitExerciseMode() {
    this.gridService.quitExerciseMode();
    // Reset the turtle to the initial position
    this.canvasService.clearScreen();
    this.blocks.clearWorkspace();
    this.blocks.clearHistory();
    this.canvasService.drawTurtleInit();
    this.flush();
  }

  drawExercise() {
    if (!this.teacherToolService.checkIfTurtleSet()) {
      return;
    }
    let modal = document.getElementById("createExerciseModal");
    this.teacherToolService.exportExercise();
    modal.style.display = "none";
  }

  saveTaskToServer() {
    if (!this.teacherToolService.checkIfTurtleSet()) {
      return;
    }
    this.teacherToolService.saveTaskToServer();
  }

  localDownloadTask() {
    if (!this.teacherToolService.checkIfTurtleSet()) {
      return;
    }
    this.teacherToolService.downloadTask();
  }

  clearTeacherTool() {
    this.teacherToolService.clear();
  }

  getInput() {
    this.teacherToolService.getInput();
  }
}

// vim: shiftwidth=2



// WEBPACK FOOTER //
// ./src/app/components/canvas.component.ts